import {ReadyProvider} from '../../../application/providers/readyProvider';
import {SubscriptionForm} from '../subscription/subscriptionForm';
import {PaginatedContent} from "../../../application/contentLoaders/paginatedContent";

ReadyProvider.executeOnReady(() => {
    new SubscriptionForm(document.querySelector('[data-subsctiption="form"]'));
    new PaginatedContent(document.querySelector('[data-page="content"]'))
});
